import React, { useEffect, useState } from 'react';
import { HbrSpinner } from '@harbor/elements-react-standalone';

import { describeDataSources } from '../../support/dataSourceLabel';

interface Props {
  queries?: Array<{ path?: string; dataSource?: string }> | null;
  /** Shown when no system can be named. */
  fallback?: string;
}

/** Seconds before the message admits the wait is longer than usual. */
const SLOW_AFTER = 8;

/** A spinner that says which system the data is coming from, and owns up when it is taking a while. */
const DataLoading: React.FC<Props> = ({ queries, fallback = 'Loading…' }) => {
  const source = describeDataSources(queries);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);

  const slow = seconds >= SLOW_AFTER;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, textAlign: 'center' }}>
      <HbrSpinner>{source ? `Waiting on ${source}…` : fallback}</HbrSpinner>
      {slow && (
        <span className="hbr-css__text-secondary-sm">
          {source ? `${source} is taking longer than usual` : 'Still working'} ({seconds}s)
        </span>
      )}
    </div>
  );
};

export default DataLoading;
